export default {
  async request(config = {}) {
    return this.$post({
      url: `${this.$baseurl}/otp/request`,
      headers: this.headers,
      ...config,
    });
  },
};
